/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { calculateDiscountComboItemRequestSchema } from "./calculateDiscountComboItemRequestSchema.ts";

export const calculateDiscountComboGroupRequestSchema = z.object({
	id: z.uuid(),
	item: calculateDiscountComboItemRequestSchema.describe("Уменьшение стоимости модификаторов позиции на бесплатные единицы."),
});
